import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SimpleHeader from '../../components/SimpleHeader';
import { MASA_KARTI_TASARIMLARI, EL_KARTI_TASARIMLARI } from '../../data/packages';
import { createOrganizationOrder } from '../../services/apiService';

const BANK_TRANSFER_INFO = {
  bankName: 'Garanti BBVA',
  accountName: 'ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ',
  iban: 'TR73 0006 2000 7210 0006 2913 93',
  explanationNote: 'Açıklamaya organizasyon firma adınızı eklemeyi unutmayınız.',
};

export default function OrgBuyPackage() {
  const navigate = useNavigate();

  const CREDIT_PACKAGES = [
    { label: '1 Düğün Paketi', qty: 1, price: 1000 },
    { label: '10 Düğün Paketi', qty: 10, price: 8500 },
    { label: '20 Düğün Paketi', qty: 20, price: 15000 },
    { label: '30 Düğün Paketi', qty: 30, price: 20000 },
    { label: '50 Düğün Paketi', qty: 50, price: 30000 },
  ];

  const [selectedPackageIndex, setSelectedPackageIndex] = useState(0);
  const selectedPackage = CREDIT_PACKAGES[selectedPackageIndex];
  const creditsQty = selectedPackage.qty;
  const creditsPrice = selectedPackage.price;

  const [tableCardsQty, setTableCardsQty] = useState(0);
  const [tableCardDesign, setTableCardDesign] = useState('');
  const [handCardsQty, setHandCardsQty] = useState(0);
  const [handCardDesign, setHandCardDesign] = useState('');

  const [paymentMethod, setPaymentMethod] = useState('card');
  const [isLoading, setIsLoading] = useState(false);

  // Load user data if needed natively or leave blank
  useEffect(() => {
    // Optionally pre-fill from context/auth
    if (!tableCardDesign) setTableCardDesign(MASA_KARTI_TASARIMLARI[0]?.id || '');
    if (!handCardDesign) setHandCardDesign(EL_KARTI_TASARIMLARI[0]?.id || '');
  }, []);

  // Calculations
  const calcBaseTotal = () => {
    return creditsPrice + (tableCardsQty * 8) + (handCardsQty * 3);
  };

  const vatAmount = calcBaseTotal() * 0.20;
  const subtotalWithVat = calcBaseTotal() + vatAmount;

  const finalTotal = subtotalWithVat;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (creditsQty < 1) {
      alert("En az 1 Düğün Hakkı/Kredisi satın almalısınız.");
      return;
    }

    setIsLoading(true);

    const payload = {
      creditsQty,
      creditsPrice,
      tableCardsQty,
      tableCardDesign,
      handCardsQty,
      handCardDesign,
      paymentMethod
    };

    try {
      const response = await createOrganizationOrder(payload);

      if (paymentMethod === 'card' && response.paymentLink) {
        window.location.href = response.paymentLink; // Redirect to Lidio
      } else if (paymentMethod === 'bank_transfer') {
        navigate('/organization/dashboard');
        alert("Havale siparişiniz başarıyla alındı! Yönetici onayından sonra kredi bakiyenize eklenecektir.");
      } else {
        alert("Sipariş işleme alındı fakat statüsü bilinmiyor.");
      }

    } catch (error) {
      console.error(error);
      alert(`Sipariş oluşturulamadı. Hata: ${error.message || 'Sunucu hatası'}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-rose-50 min-h-screen">
      <SimpleHeader />
      <main className="mx-auto max-w-6xl px-4 pt-24 pb-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold text-gray-800">Düğün Kredisi / Baskı Siparişi</h1>
          <p className="mt-2 text-gray-600">
            Organizasyonlar için özel fiyatlandırılmış düğün paketi ve basılı materyalleri buradan satın alabilirsiniz.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-2 space-y-6">

            {/* Ürün Seçimi */}
            <div className="bg-white p-6 rounded-xl shadow-md border">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Ürün Miktarları</h2>

              <div className="space-y-4">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b pb-4 gap-4">
                  <div>
                    <h3 className="font-semibold text-gray-800">Düğün Kredisi Paketleri</h3>
                    <p className="text-sm text-gray-500">Toplu alımlarda indirimli fiyatlar (KDV Hariç)</p>
                  </div>
                  <select
                    value={selectedPackageIndex}
                    onChange={(e) => setSelectedPackageIndex(Number(e.target.value))}
                    className="border rounded-lg p-2 font-medium"
                  >
                    {CREDIT_PACKAGES.map((pkg, idx) => (
                      <option key={idx} value={idx}>
                        {pkg.label} - {pkg.price.toLocaleString('tr-TR')} ₺
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex items-center justify-between border-b pb-4">
                  <div>
                    <h3 className="font-semibold text-gray-800">Ek Masa Kartı</h3>
                    <p className="text-sm text-gray-500">Adet başı 8 ₺</p>
                  </div>
                  <input type="number" min="0" value={tableCardsQty} onChange={(e) => setTableCardsQty(Number(e.target.value))} className="border rounded p-2 text-center w-24" />
                </div>

                {tableCardsQty > 0 && (
                  <div className="pb-4 border-b">
                    <label className="block text-sm font-semibold mb-2">Masa Kartı Tasarımı:</label>
                    <select value={tableCardDesign} onChange={(e) => setTableCardDesign(e.target.value)} className="w-full border rounded p-2">
                      {MASA_KARTI_TASARIMLARI.map(d => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="flex items-center justify-between border-b pb-4">
                  <div>
                    <h3 className="font-semibold text-gray-800">Ek El Kartı</h3>
                    <p className="text-sm text-gray-500">Adet başı 3 ₺</p>
                  </div>
                  <input type="number" min="0" value={handCardsQty} onChange={(e) => setHandCardsQty(Number(e.target.value))} className="border rounded p-2 text-center w-24" />
                </div>

                {handCardsQty > 0 && (
                  <div className="pb-4 border-b">
                    <label className="block text-sm font-semibold mb-2">El Kartı Tasarımı:</label>
                    <select value={handCardDesign} onChange={(e) => setHandCardDesign(e.target.value)} className="w-full border rounded p-2">
                      {EL_KARTI_TASARIMLARI.map(d => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            {/* Ödeme Yöntemi */}
            <div className="bg-white p-6 rounded-xl shadow-md border space-y-4">
              <h2 className="text-xl font-bold text-gray-800 mb-2">Ödeme Yöntemi</h2>
              <div className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="radio" value="bank_transfer" checked={paymentMethod === 'bank_transfer'} onChange={() => setPaymentMethod('bank_transfer')} className="mt-1" />
                  <div>
                    <div className="font-semibold text-gray-800">Banka Havalesi / EFT</div>
                    <div className="text-xs text-gray-500">Doğrudan IBAN üzerinden komisyonsuz transfer. Onay gerektirir.</div>
                  </div>
                </label>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="radio" value="card" checked={paymentMethod === 'card'} onChange={() => setPaymentMethod('card')} className="mt-1" />
                  <div>
                    <div className="font-semibold text-gray-800">Kredi/Banka Kartı (3 Taksit İmkanı)</div>
                  </div>
                </label>
              </div>

              {paymentMethod === 'bank_transfer' && (
                <div className="p-4 bg-gray-50 border rounded-md text-sm text-gray-800 mt-4">
                  <p className="font-semibold mb-2">Lütfen ödemeyi şu hesaba havale yapın:</p>
                  <p>Banka: {BANK_TRANSFER_INFO.bankName}</p>
                  <p>Alıcı: {BANK_TRANSFER_INFO.accountName}</p>
                  <p className="font-mono mt-1 font-bold">{BANK_TRANSFER_INFO.iban}</p>
                  <p className="text-xs text-gray-500 mt-2">{BANK_TRANSFER_INFO.explanationNote}</p>
                </div>
              )}
            </div>

          </div>

          {/* Sağ Kolon (Özet) */}
          <div className="lg:col-span-1 border rounded-xl overflow-hidden shadow-md bg-white sticky top-24">
            <h2 className="text-lg font-bold bg-[#FDE2EC] text-[#a02c4f] p-4 border-b border-[#F7Cddc]">
              Sipariş Özeti
            </h2>
            <div className="p-4 space-y-3 text-sm text-gray-800">
              <div className="flex justify-between">
                <span>{creditsQty}x Kredi ({selectedPackage.label})</span>
                <span>{creditsPrice.toLocaleString('tr-TR')} ₺</span>
              </div>
              {tableCardsQty > 0 && (
                <div className="flex justify-between">
                  <span>{tableCardsQty}x Masa Knt.</span>
                  <span>{(tableCardsQty * 8).toLocaleString('tr-TR')} ₺</span>
                </div>
              )}
              {handCardsQty > 0 && (
                <div className="flex justify-between">
                  <span>{handCardsQty}x El Knt.</span>
                  <span>{(handCardsQty * 3).toLocaleString('tr-TR')} ₺</span>
                </div>
              )}

              <hr className="my-2 border-gray-200" />
              <div className="flex justify-between text-gray-500 font-semibold">
                <span>Ara Toplam (+KDV'siz)</span>
                <span>{calcBaseTotal().toLocaleString('tr-TR')} ₺</span>
              </div>
              <div className="flex justify-between text-gray-500 font-semibold">
                <span>%20 KDV</span>
                <span>{vatAmount.toLocaleString('tr-TR')} ₺</span>
              </div>
              <hr className="my-2 border-gray-200" />
              <div className="flex justify-between text-lg font-bold mt-2 text-[#E45078]">
                <span>Genel Toplam</span>
                <span>{finalTotal.toLocaleString('tr-TR')} ₺</span>
              </div>
            </div>

            <div className="p-4 bg-gray-50 border-t">
              <button disabled={isLoading} className="w-full bg-[#E45078] hover:bg-rose-600 text-white font-bold py-3 px-4 rounded-lg transition disabled:opacity-50">
                {isLoading ? (paymentMethod === 'card' ? 'Lidio\'ya yönlendiriliyor...' : 'İşleniyor...') : 'Siparişi Tamamla'}
              </button>
            </div>
          </div>

        </form>
      </main>
    </div>
  );
}
